import React from 'react';

import { Button } from '@components/Button';
import { ActionableDialog, ActionableDialogTitle } from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    ...common.flexInline,
    ...common.fontWeight700,
    padding: '17px 10px',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    alignItems: 'center',
  },
  body: {
    ...common.flexColumn,
    padding: '40px 30px',
    flexShrink: 1,
    minHeight: 0,
    overflow: 'auto',
  },
  actions: {
    ...common.flexInline,
    justifyContent: 'center',
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    padding: 32,
    columnGap: 64,
  },
  paper: {
    maxWidth: '700px',
  },
}));

const strings = createStrings({
  ja: {
    confirmChangeEmail: (email: string) => (
      <>
        メールアドレスを<span style={{ color: '#CF3F1B' }}>{email}</span>に変更されますか？
      </>
    ),
    afterChangeEmail:
      '「OK」をクリックすると現在のメールアドレスではD2Dにログインできなくなりますので、ご注意ください。',
  },
});

interface EmailChangePromptDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
}

export const EmailChangePromptDialog: React.FC<EmailChangePromptDialogProps> = (props) => {
  const { open, title, onClose, onConfirm, email } = props;
  const classes = {
    ...useStyles(),
    ...useCommonStyles(),
  };

  return (
    <ActionableDialog onClose={onClose} open={open} classes={{ paper: classes.paper }}>
      <ActionableDialogTitle>
        <div className={classes.title}>{title}</div>
      </ActionableDialogTitle>
      <div className={classes.body}>
        <div className={clsx(classes.normalText, classes.fontWeight700)}>
          {strings.confirmChangeEmail(email)}
        </div>
        <br />
        <div className={classes.smallerText}>{strings.afterChangeEmail}</div>
      </div>
      <div className={classes.actions}>
        <Button
          color="primary"
          size="small"
          shape="round"
          text={formStrings.ok}
          style={{ minWidth: 80 }}
          onClick={onConfirm}
        />
      </div>
    </ActionableDialog>
  );
};
